<div class="inline-flex items-center gap-1" data-testid="price-switcher">
  <button
    type="button"
    class="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-sm font-medium hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
    [cdkMenuTriggerFor]="menu"
    [cdkMenuPosition]="positions"
    [disabled]="busy()"
    data-testid="price-switcher-trigger"
  >
    Price {{ active()?.position ?? "?" }} of {{ entries().length }}
    <span aria-hidden="true">▾</span>
  </button>
  <button
    type="button"
    class="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
    aria-label="Previous price"
    [disabled]="busy() || !prev()"
    (click)="step(prev())"
    data-testid="price-switcher-prev"
  >
    ‹
  </button>
  <button
    type="button"
    class="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
    aria-label="Next price"
    [disabled]="busy() || !next()"
    (click)="step(next())"
    data-testid="price-switcher-next"
  >
    ›
  </button>

  <ng-template #menu>
    <div
      cdkMenu
      class="enr-bg-surface max-h-96 w-96 overflow-auto rounded-lg border border-gray-200 p-1 shadow-lg"
      aria-label="Prices of this package"
      data-testid="price-switcher-menu"
    >
      @for (entry of entries(); track entry.id) {
      <button
        type="button"
        cdkMenuItemRadio
        [cdkMenuItemChecked]="entry.id === activeId()"
        class="flex w-full items-center justify-between gap-3 rounded-md px-3 py-2 text-left hover:bg-gray-50 focus-visible:bg-gray-50"
        [class.bg-green-50]="entry.id === activeId()"
        (cdkMenuItemTriggered)="pick(entry.id)"
        [attr.data-testid]="'price-switcher-option-' + entry.id"
      >
        <span class="flex min-w-0 flex-col">
          <span class="truncate text-sm font-medium">{{ entry.title }}</span>
          <span class="enr-text-surface text-xs">
            {{ figures(entry) || "No amount" }} · {{ entry.id }}
          </span>
        </span>
        @if (entry.status; as status) {
        <enr-status
          size="small"
          [status]="status.type"
          [customText]="status.label"
        />
        }
      </button>
      }
      <p class="enr-text-surface m-0 px-3 py-2 text-xs">
        Switching asks to save or discard unsaved changes first.
      </p>
    </div>
  </ng-template>
</div>
